<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Datei erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.attachments.store'))">
                <form-fields :form="form" :purpose-options="purposeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
            'purposeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    title: null,
                    slug: null,
                    source_url: null,
                    alt_text: null,
                    purpose: null,
                    copyright: null,
                    description: null,
                    sort_order: null,
                    upload_file: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>